import { render, staticRenderFns } from "./ExpenseCategorySetup.vue?vue&type=template&id=7afea0dc&"
import script from "./ExpenseCategorySetup.vue?vue&type=script&lang=js&"
export * from "./ExpenseCategorySetup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports